import React from 'react';
import { Card, CardHeader } from '../../components/Bootstrap';
import { BarList } from '../../components/BarList';
import { ButtonSelect } from '../../components/ButtonSelect';
import { DemographicsQuery_demographics } from './__generated__/DemographicsQuery';

type TopCustomersProps = {
  topCustomersOrders: DemographicsQuery_demographics['topCustomersDrinks'];
  topCustomersDrinks: DemographicsQuery_demographics['topCustomersOrders'];
};

export class TopCustomers extends React.Component<TopCustomersProps, any> {
  constructor(props) {
    super(props);

    this.state = {
      stat: 'Orders',
    };

    this.handleStatChange = this.handleStatChange.bind(this);
  }

  handleStatChange(newValue) {
    this.setState({
      stat: newValue,
    });
  }

  render() {
    const { topCustomersOrders, topCustomersDrinks } = this.props;

    const stat: any[] = this.state.stat === 'Orders' ? topCustomersOrders : topCustomersDrinks;

    const total = stat.reduce((accum, val) => {
      return accum + Number(val.count);
    }, 0);

    const counts = stat.map((row) => {
      return {
        name: [row.firstName, row.lastName].filter(Boolean).join(' '),
        progressValue: Number(row.count) / total,
        value: row.count,
      };
    });

    return (
      <Card className='top-customers border-0'>
        <CardHeader>Top 15 Customers</CardHeader>
        <div className='text-center'>
          <ButtonSelect
            type='selector'
            className='top-customers-selector'
            options={['Orders', 'Items']}
            onChange={this.handleStatChange}
            selected={this.state.stat}
          />
        </div>
        <BarList data={counts} />
      </Card>
    );
  }
}
